<template>
  <div class="CodeSnippet layout-container" :class="desktopWidth('sm')">
    <div
      ref="el"
      :class="{'hidden': !blok.visible}"
      class="w-full iframe-wrapper"
    />
  </div>
</template>

<script setup lang="ts">
import { StoryBlokPropBase } from '~/constants/types/storyblok';
import { ref, onMounted } from 'vue';
import useDesktopWidth from '~/composeables/useDesktopWidth';

type Props = StoryBlokPropBase & {
  code: string,
  visible: boolean,
}

const props = defineProps<{
  blok: Props,
}>();

const { desktopWidth } = useDesktopWidth(props);
const el = ref(null) as any;

onMounted(() => {
  el.value.innerHTML = props.blok.code;
  const scriptsTags = el.value.getElementsByTagName('script');

  for (let i = 0; i < scriptsTags.length; i++) {
    const parentNode = scriptsTags[i].parentNode;
    const newScriptTag = document.createElement('script');
    newScriptTag.type = 'text/javascript';
    newScriptTag.text = scriptsTags[i].text;
    parentNode?.removeChild(scriptsTags[i]);
    parentNode?.appendChild(newScriptTag);
  }
});

</script>

<style lang="postcss">
.iframe-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  /* 16:9 */
  padding-top: 25px;
  height: 0;
}

.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
